import { useEffect, useState } from "react";
import './Pincode.css'
import Swal from "sweetalert2";

const PincodeManager = () => {
  const [pincode, setPincode] = useState("");
  const [pincodes, setPincodes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchPincodes();
  }, []);

  const fetchPincodes = async () => {
    setLoading(true);
    setError(null);
    const adminToken = localStorage.getItem("admintoken");

    if (!adminToken) {
      setError("Admin token not found");
      setLoading(false);
      return;
    }

    try {
      const response = await fetch("https://admin.riymay.com/api/v1/admin/all/pincodes", {
        headers: {
          Authorization: `Bearer ${adminToken}`,
        },
      });
      const data = await response.json();
      if (response.ok) {
        setPincodes(data.pinCodes);
      } else {
        setError(data.message || "Failed to fetch pincodes");
      }
    } catch (err) {
      setError("Network error");
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async () => {
    setLoading(true);
    setError(null);
    const adminToken = localStorage.getItem("admintoken");

    if (!adminToken) {
      setError("Admin token not found");
      setLoading(false);
      return;
    }

    try {
      const response = await fetch("https://admin.riymay.com/api/v1/admin/create/pincode", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${adminToken}`,
        },
        body: JSON.stringify({ pincode }),
      });
      const data = await response.json();
      if (response.ok) {
        fetchPincodes();
        setPincode("");
      } else {
        setError(data.message || "Failed to create pincode");
      }
    } catch (err) {
      setError("Network error");
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (pincode) => {

    const confirmation = await Swal.fire({
      title: "Are you sure?",
      text: "Do you want to delete this pincode?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, cancel!",
    });

    if (confirmation.isConfirmed) {

      setLoading(true);
      setError(null);
      const adminToken = localStorage.getItem("admintoken");
  
      if (!adminToken) {
        setError("Admin token not found");
        setLoading(false);
        return;
      }
  
      try {
        const response = await fetch("https://admin.riymay.com/api/v1/admin/delete/pincode", {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${adminToken}`,
          },
          body: JSON.stringify({ pincode }),
        });
        const data = await response.json();
        if (response.ok) {
          fetchPincodes();
          Swal.fire(data.message)
  
        } else {
          setError(data.message || "Failed to delete pincode");
        }
      } catch (err) {
        setError("Network error");
      } finally {
        setLoading(false);
      }
    };

  }
    
    

  return (
    <div className="table-container">
  
    {/* Input Section */}
    <div className="search-bar-container">
    <h1 >Pincode Manager</h1>

      <input
       type="text"
       value={!error ? pincode : error}
       onChange={(e) => setPincode(e.target.value)}
       placeholder="Enter pincode"
       className={`search-bar ${error ? "error-input" : ""}`}
      />
      <button onClick={handleSubmit} disabled={loading} className="pincode-submit-btn">
        {loading ? "Submitting..." : "Submit"}
      </button>
    </div>


    {/* Pincode List */}
    <h2 className="pincode-list-heading">Pincode List</h2>
    {loading ? (
      <p className="pincode-loading">Loading...</p>
    ) : (
      <div className="pincode-table-container">
        <table className="pincode-table">
          <thead className="pincode-table-head">
            <tr className="pincode-table-row">
              <th className="pincode-table-header">ID</th>
              <th className="pincode-table-header">Pincode</th>
              <th className="pincode-table-header">Added Date</th>
              <th className="pincode-table-header">Action</th>
            </tr>
          </thead>
          <tbody className="pincode-table-body">
            {pincodes.map((item) => (
              <tr key={item._id} className="pincode-table-row">
<td className="pincode-table-data">{item._id.substring(0, 10)}</td>
<td className="pincode-table-data">{item.pincode}</td>
                <td className="pincode-table-data">{new Date(item.addedDate).toLocaleString()}</td>
                <td className="pincode-table-data">
                  <button
                    className="pincode-delete-btn"
                    onClick={() => handleDelete(item.pincode)}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    )}
  </div>
  
  );
};

export default PincodeManager;
